module.exports = __webpack_public_path__ + "img/qrcode-bg.fe791445.png";